import React from 'react';
import { SdfBox } from '@synerg/react-components';
import { SdfQuickStat } from '@synerg/react-components';
import { SdfRadioButton } from '@synerg/react-components';
import { SdfSpotIllustration } from '@synerg/react-components';
import {CustomToolTip} from 'shared-one-ux-components';

export default function StepOne({
	useCases,
	selectedUseCaseBtnIndex,
	setSelectedUseCaseBtnIndex,
	setValue,
	state
}) {
	const { clientName, product } = state;
	function getIllustrationByCategory(category) {
		switch (category) {
			case 'benefits':
				return 'health-crest';
			case 'benefits administration':
				return 'heart-hands';
			case 'compliance':
				return 'clipboard';
			case 'empIncomeVerification':
				return 'magnifying-glass-recruiter';
			case 'learning management':
				return 'certificate';
			case 'other':
				return 'shield';
			case 'productivity & collaboration':
				return 'high-five';
			case 'performance':
				return 'trophy';
			case 'payroll':
				return 'money-hand';
			case 'retention':
				return 'connections';
			case 'recruiting':
				return 'people-3';
			case 'time':
				return 'time-sheets';
			default:
				return 'warning';
		}
	}

	return (<div>
		<div className="mt-8">
			<span
				className="text-heading-05 font-bold mb-4	">Use case selection</span>
			<div className="flex flex-row items-center pb-1 pt-4" style={{maxWidth:'59rem'}}>
				<div className="order-1 w-16">
					<label className="text-heading-03 font-bold">Client:</label>
				</div>
				<div className="order-2 w-3/4">
					<div className="capitalize" style={{paddingTop:'2px'}}>
						<div><CustomToolTip text={clientName} startEllipsisLen="51"
							 width="50%" enableBoldFont={false} />
						</div>
					</div>
				</div>
			</div>
			<div className="flex flex-row items-center pb-2">
				<div className="order-1 w-20">
					<label className="text-heading-03 font-bold">Product:</label>
				</div>
				<div className="order-2 w-3/4">
					<div className="capitalize" style={{paddingTop:'2px'}}>{product}</div>
				</div>
			</div>
			<p className="text-body-02 mb-6">Select a use case that best describes
				the type of data you need for your integration. This use case will
				give you a basic set of APIs to get started. Don't worry you can
				always add additional APIs later.</p>
			<span className="text-heading-05 font-bold">Which bundled data set best fits your integration use case?</span>

			<div className="mt-8 overflow-y-scroll p-1 max-w-3xl"
				style={{ height: '24rem' }}>
				<section data-cvs-id="appStore-US"
					className="items-center justify-center	grid grid-cols-3 gap-4">
					{useCases && useCases.map(
						({ _id: id, title, description, category }, index) => (<SdfBox
							style={{ height: '270px' }}
							variant="bordered"
							spacing="default"
							className="justify-center min-h-24 max-h-30 w-60"
							key={index}
							onClick={() => {
								//add use case id and user case name
								setSelectedUseCaseBtnIndex(index);
								setValue('useCaseID', id);
								setValue('useCaseName', title);
							}}
						>
							<SdfQuickStat size="md">
								<div className="flex text-sm">
									<SdfRadioButton value="US" checked={index ===
										selectedUseCaseBtnIndex} />
								</div>
							</SdfQuickStat>
							<div
								className="flex flex-col items-center overflow-hidden px-2">
								<SdfSpotIllustration
									illustrationName={getIllustrationByCategory(
										category)}
									size={'sm'}
								/>
								<div
									className="text-heading-04 font-bold text-center capitalize mt-2">{title}</div>
							</div>
						</SdfBox>))}
				</section>
			</div>

		</div>
	</div>);
}
